export default __webpack_public_path__ + "b16d80d8bae3fd0a4282b5520493ca06.png";